import { CircleCheck, RotateCcw } from 'lucide-react'
import React from 'react'

interface EmailSignupSuccessProps {
  onRetry: () => void
}

export const EmailSignupSuccess: React.FC<EmailSignupSuccessProps> = ({ onRetry }) => {
  return (
    <div className="flex items-center justify-between gap-2 px-4 pr-0.5  h-[48px] rounded-md bg-black/60 border border-green-500/30">
      <div className="flex items-center gap-1.5">
        {/* <svg className="w-5 h-5 text-green-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
        </svg> */}
        <CircleCheck size={20} className="text-green-400" />
        <span className="text-green-500 text-sm font-semibold">Check your email for instant login link!</span>
      </div>
      <button
        type="button"
        onClick={onRetry}
        className="text-white hover:text-black h-[30.5px]  hover:bg-white/80  px-2 rounded-sm  font-bold underline transition-colors"
      >
        <RotateCcw className='' strokeWidth={3} size={18}/>
      </button>
    </div>
  )
}

